import { skillCooldownMs } from "@/character/skills/constants";
import type { SkillBarState, SkillDefinition } from "@/character/skills/types";
import type { HomeEconomy } from "@/home/economy";

export function skillCooldownCardsApplied(skill: SkillDefinition): number {
  const n = skill.cooldownCards ?? 0;
  return Math.max(0, Math.floor(n));
}

export function skillEffectiveCooldownMs(skill: SkillDefinition): number {
  return skillCooldownMs(skillCooldownCardsApplied(skill));
}

export type UpgradeSkillCooldownResult =
  | { ok: true; economy: HomeEconomy; skill: SkillDefinition }
  | { ok: false; reason: string };

export function upgradeSkillWithCooldownCard(
  economy: HomeEconomy,
  skill: SkillDefinition,
): UpgradeSkillCooldownResult {
  const applied = skillCooldownCardsApplied(skill);
  if (economy.skillCooldownCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรในคลัง · ซื้อที่ร้านในบ้าน" };
  }
  return {
    ok: true,
    economy: {
      ...economy,
      skillCooldownCards: economy.skillCooldownCards - 1,
    },
    skill: {
      ...skill,
      cooldownCards: applied + 1,
    },
  };
}

/** Old saves: global card count → per-skill, then clear inventory-style global apply. */
export function migrateLegacyGlobalCooldownCards(
  bar: SkillBarState,
  economy: HomeEconomy,
): { bar: SkillBarState; economy: HomeEconomy; changed: boolean } {
  const legacy = economy.skillCooldownCards;
  if (legacy <= 0 || bar.library.length === 0) {
    return { bar, economy, changed: false };
  }
  const anyApplied = bar.library.some((s) => skillCooldownCardsApplied(s) > 0);
  if (anyApplied) {
    return { bar, economy, changed: false };
  }
  const cards = legacy;
  return {
    bar: {
      ...bar,
      library: bar.library.map((s) => ({ ...s, cooldownCards: cards })),
    },
    economy: { ...economy, skillCooldownCards: 0 },
    changed: true,
  };
}
